module.exports = __webpack_public_path__ + "static/img/preview_title1.8418307.png";


//////////////////
// WEBPACK FOOTER
// ./static/funding_cpunk/creation/preview_title1.png
// module id = xFIV
// module chunks = 1